import { Link } from '@triumph/design-system';

import { CopyOrpLinkButton } from '../CopyOrpLinkButton';

const FEEDBACK_CHANNEL_URL = 'https://triumph.enterprise.slack.com/archives/C0987QFTQ00';

export const FeedbackChannelLink = () => (
    <Link
        href={FEEDBACK_CHANNEL_URL}
        title="originations-review-portal-feedback"
        data-testid="originations-review-portal-slack-link"
    >
        #orp-originations-review-portal-feedback
    </Link>
);

interface SupportContactMessageProps {
    lead: string;
    copyLinkTestId?: string;
}

export const SupportContactMessage = ({ lead, copyLinkTestId }: SupportContactMessageProps) => (
    <>
        {lead} Please reload or contact the dev team in <FeedbackChannelLink /> and attach the URL{' '}
        <CopyOrpLinkButton label="📄 ORP Link" data-testid={copyLinkTestId} />
    </>
);
